/* eslint-disable eqeqeq */
/**
 * request.js
 * 通过promise对axios做二次封装，针对用户端参数，做灵活配置
 */
import { ElNotification, ElLoading } from 'element-plus'
import instance from '@/api/network/interceptor.js'
import gotoLoginDialog from '@/api/utils/gotoLogin.js'

const headers = {
    'Content-Type': 'application/json;charset=UTF-8'
}

const typeOf = data => {
    let type = Object.prototype.toString.call(data)
    if (type === '[object String]') {
        type = 'String'
    } else if (type === '[object Number]') {
        type = 'Number'
    } else if (type === '[object Null]') {
        type = 'Null'
    } else if (type === '[object Boolean]') {
        type = 'Boolean'
    } else if (type === '[object Array]') {
        type = 'Array'
    } else if (type === '[object Object]') {
        type = 'Object'
    } else {
        type = '未进行判断的类型:' + type
    }
    return type
}

/*
* code 0 表示正常  -1表示结果异常  -2表示session失效
* normalShowDialog true 正常，弹出提示框  false 不弹出提示框
* errorShowDialog  true 错误，弹出提示框  false 不弹出提示框
* exceptionShowDialog    true  异常，弹出提示框  false  不弹出提示框
* showLoadingDialog      true  弹出等待提示     false   不弹出等待提示
* */
let msgIns = null
function request (url, params, method, headers, normalShowDialog, errorShowDialog, exceptionShowDialog, showLoadingDialog) {
    params.token = sessionStorage.getItem('token')
    // 去掉参数中的前后空格和换行符
    for (const key in params) {
        let value = params[key]
        if (typeOf(value) === 'String') {
            value = value.trim()
            params[key] = value
        }
    }
    return new Promise((resolve, reject) => {
        let loading = null
        if (showLoadingDialog === true) {
            loading = ElLoading.service()
        }
        let data = {}
        if (method === 'get') data = { params }
        if (method === 'post') data = { data: params }
        instance({
            url,
            method,
            headers,
            ...data
        }).then((res) => {
            if (typeof res === 'undefined') {
                gotoLoginDialog.showDialog('无效响应，请稍后再试。')
                reject(new Error('无效响应'))
                return
            }
            if ([101, 102, 103, 104].includes(res.code)) {
                gotoLoginDialog.showDialog(res.msg)
                reject(new Error(res.msg))
                return
            }
            if (res.code === 0) {
                if (normalShowDialog === true) {
                    if (msgIns) {
                        msgIns.close()
                    }
                    msgIns = ElNotification({
                        dangerouslyUseHTMLString: true,
                        title: '提示',
                        message: res.msg,
                        duration: 3000,
                        type: 'success',
                        offset: 0,
                        customClass: 'el-notification--success'
                    })
                }
            }
            if (res.code === -1) {
                if (errorShowDialog === true) {
                    if (msgIns) {
                        msgIns.close()
                    }
                    msgIns = ElNotification({
                        dangerouslyUseHTMLString: true,
                        title: '提示',
                        message: res.msg,
                        duration: 5000,
                        type: 'error',
                        offset: 0,
                        customClass: 'el-notification--error'
                    })
                }
            }
            resolve(res)
        }).catch((e) => {
            if (exceptionShowDialog === true) {
                msgIns = ElNotification({
                    dangerouslyUseHTMLString: true,
                    title: '提示',
                    message: e.message,
                    duration: 5000,
                    type: 'error',
                    offset: 0,
                    customClass: 'el-notification--error'
                })
            }
            reject(e)
        }).finally(() => {
            if (showLoadingDialog === true) {
                loading.close()
            }
        })
    })
}

function showErrorMsg (msg) {
    msgIns = ElNotification({
        dangerouslyUseHTMLString: true,
        title: '提示',
        message: msg,
        duration: 5000,
        type: 'error',
        offset: 0,
        customClass: 'el-notification--error'
    })
}

function requestExcel (url, params, method, responseType) {
    params.token = sessionStorage.getItem('token')
    for (const key in params) {
        let value = params[key]
        if (typeOf(value) === 'String') {
            value = value.trim()
            params[key] = value
        }
    }
    return new Promise((resolve, reject) => {
        const loading = ElLoading.service()
        const data = { data: params }
        instance({ url, method, headers, responseType, ...data }).then((res) => {
            loading.close()
            // 检查响应是否为 JSON 格式的错误信息
            if (res.type && res.type === 'application/json') {
                const reader = new FileReader()
                reader.onload = function () {
                    const responseText = reader.result
                    try {
                        const rs = JSON.parse(responseText)
                        if (rs.code !== 0) {
                            showErrorMsg(rs.msg || '导出失败，请重试')
                            return false
                        }
                    } catch (e) { showErrorMsg('无效响应，请稍后再试') }
                }
                reader.readAsText(res)
                return // 如果是错误信息，则不进行文件下载
            }
            // 如果是正常的文件响应
            const downFilename = typeof (params.downFilename) !== 'undefined' ? params.downFilename : new Date().getTime().toString() + '.xlsx'
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
            var downloadElement = document.createElement('a')
            var href = window.URL.createObjectURL(blob)
            downloadElement.href = href
            downloadElement.download = downFilename
            document.body.appendChild(downloadElement)
            downloadElement.click()
            document.body.removeChild(downloadElement)
            window.URL.revokeObjectURL(href)

            resolve(res)
        }).catch((e) => {
            showErrorMsg('服务器错误或网络问题，请稍后再试')
            reject(e)
        }).finally(() => {
            loading.close()
        })
    })
}

function requestFile (url, params, method, responseType) {
    params.token = sessionStorage.getItem('token')
    for (const key in params) {
        let value = params[key]
        if (typeOf(value) === 'String') {
            value = value.trim()
            params[key] = value
        }
    }
    return new Promise((resolve, reject) => {
        const loading = ElLoading.service()
        const data = { data: params }
        instance({ url, method, headers, responseType, ...data }).then((res) => {
            loading.close()
            // 检查响应是否为 JSON 格式的错误信息
            if (res.type && res.type === 'application/json') {
                const reader = new FileReader()
                reader.onload = function () {
                    const responseText = reader.result
                    try {
                        const rs = JSON.parse(responseText)
                        if (rs.code !== 0) {
                            showErrorMsg(rs.msg || '导出失败，请重试')
                            return false
                        }
                    } catch (e) { showErrorMsg('无效响应，请稍后再试') }
                }
                reader.readAsText(res)
                return // 如果是错误信息，则不进行文件下载
            }
            // 如果是正常的文件响应
            const ext = typeof (params.ext) !== 'undefined' ? params.ext : 'zip'
            const downFilename = typeof (params.downFilename) !== 'undefined' ? params.downFilename : new Date().getTime().toString() + '.' + ext
            let type = ''
            switch (ext) {
                case 'gif':
                    type = 'image/gif'
                    break
                case 'png':
                    type = 'image/png'
                    break
                case 'jpg':
                case 'jpeg':
                    type = 'image/jpeg'
                    break
                case 'txt':
                    type = 'text/plain'
                    break
                case 'doc':
                    type = 'application/msword'
                    break
                case 'docx':
                    type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    break
                case 'xls':
                    type = 'application/vnd.ms-excel'
                    break
                case 'xlsx':
                    type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    break
                case 'pdf':
                    type = 'application/pdf'
                    break
                default:
                    type = 'application/zip'
                    break
            }
            const blob = new Blob([res], { type: type })
            var downloadElement = document.createElement('a')
            var href = window.URL.createObjectURL(blob)
            downloadElement.href = href
            downloadElement.download = downFilename
            document.body.appendChild(downloadElement)
            downloadElement.click()
            document.body.removeChild(downloadElement)
            window.URL.revokeObjectURL(href)

            resolve(res)
        }).catch((e) => {
            showErrorMsg('服务器错误或网络问题，请稍后再试')
            reject(e)
        }).finally(() => {
            loading.close()
        })
    })
}

function get (url, params) {
    return request(url, params, 'get', headers, false, false, false, false)
}

//  不显示正常的提示信息，显示错误的信息，不显示loading
function post (url, params) {
    return request(url, params, 'post', headers, false, true, true, false)
}

// 显示正常的提示信息，显示错误的信息，不显示loading
function postMsg (url, params) {
    return request(url, params, 'post', headers, true, true, true, false)
}

// 不显示正常的提示信息，显示错误的信息，显示loading
function postLoading (url, params) {
    return request(url, params, 'post', headers, false, true, true, true)
}

// 显示正常的提示信息，显示错误的信息，显示loading
function postMsgLoading (url, params) {
    return request(url, params, 'post', headers, true, true, true, true)
}

// 上传文件，不显示正常的提示信息，显示错误的信息，显示loading
function postUploadFile (url, params) {
    params.append('token', sessionStorage.getItem('token'))
    const headers = { 'Content-Type': 'multipart/form-data' }
    return request(url, params, 'post', headers, false, true, true, true)
}

function exportToExcel (url, params) {
    return requestExcel(url, params, 'post', 'blob')
}

function exportFile (url, params) {
    return requestFile(url, params, 'post', 'blob')
}

export default {
    get,
    post,
    postMsg,
    postLoading,
    postMsgLoading,
    postUploadFile,
    exportToExcel,
    exportFile
}
